const GREETINGS = {
    "marin": ["marin-greeting-1.mp3", "marin-greeting-2.mp3", "marin-greeting-3.mp3", "marin-greeting-4.mp3"]
}

export default GREETINGS;